export const chartCSSVars = {
  axis: {
    color: "hsl(var(--fg-secondary))",
    titleColor: "hsl(var(--fg-secondary))",
    fontSize: "12px",
    gridColor: "var(--border-secondary)",
    tickColor: "var(--border-secondary)",
  },
  dataLabels: {
    color: "hsl(var(--fg-secondary))",
  },
  // Custom transparent. Mostly for light theme. In SVG default "transparent" turns via dark/grey-something
  transparent: "rgba(27, 27, 30, 0)",
  fontFamily: "var(--font-geist-sans)",
  navigator: {
    backgroundColor: "hsl(var(--bg-default))",
    borderColor: "var(--border-default)",
    outlineColor: "var(--border-default)",
    maskFill: `rgba(136, 138, 136, 0.1)`,
  },
  legend: {
    color: "hsl(var(--fg-default))",
    fontWeight: "500",
  },
  plotOptions: {
    areaOpacity: "0.3",
  },
  tooltip: {
    background: "hsl(var(--bg-surface))",
    color: "hsl(var(--fg-default))",
    borderColor: "var(--border-default)",
  },
}
